import { useTranslation } from 'react-i18next';
import type { Withdrawal } from '../model/types';
import { approvalViewOf, policyViewOf } from '../lib/policy-view';

export function WithdrawalMeta({ withdrawal }: { withdrawal: Withdrawal }) {
  const { t } = useTranslation('cabinet');
  const stopped = (withdrawal.effectiveStops ?? []).some((stop) => stop.active !== false);

  return (
    <div className="min-w-[8rem] space-y-1 text-xs text-muted-foreground">
      {withdrawal.amountUsdt ? <p className="text-foreground">{t('withdrawals.usdt', { amount: withdrawal.amountUsdt })}</p> : null}
      <p>{t(`withdrawals.approval.${approvalViewOf(withdrawal)}`)}</p>
      <p>{t(`withdrawals.policy.${policyViewOf(withdrawal)}`)}</p>
      {stopped && withdrawal.status !== 'paid' && withdrawal.status !== 'success' ? (
        <p className="text-destructive">{t('withdrawals.stopped')}</p>
      ) : null}
    </div>
  );
}
